module.exports = __webpack_public_path__ + "static/media/SUBMAR MATTING B.b918b061.jpg";